import React from "react";

// mitmcvc — MIT HSC Vocational (MCVC) Junior College — content in Marathi.

// Palette: Forest green + saffron + cream
export const PALETTE = {
  primary: "#14532D",
  primaryDark: "#052E16",
  accent: "#F59E0B",
  accentDark: "#B45309",
  cream: "#FEF8E8",
  ink: "#0B1F0F",
};

export const TRADES = [
  {
    key: "auto",
    nameMr: "ऑटोमोबाईल टेक्नॉलॉजी",
    nameEn: "Automobile Technology",
    qualification: "एस.एस.सी. उत्तीर्ण",
    duration: "२ वर्षे",
    intake: "३० + ३० (११वी + १२वी)",
    highlights: [
      "ऑटोमोबाईल क्षेत्रात वापरात असलेल्या सर्व टूल्स व उपकरणांची सविस्तर माहिती.",
      "पेट्रोल इंजिन, डिझेल इंजिन, सी.एन.जी., एल.पी.जी. इंधनावर चालणाऱ्या दुचाकी व चारचाकी वाहनांची देखभाल व दुरुस्ती.",
      "इंजिन दुरुस्ती, ट्रान्समिशन सिस्टीम, स्टेअरिंग सिस्टीम व ब्रेक सिस्टीमची रचना, कार्य, दुरुस्ती व टेस्टिंग — प्रात्यक्षिक ज्ञानासह.",
      "वाहनांमधील ऑटो इलेक्ट्रिक व ऑटो इलेक्ट्रॉनिक सिस्टीमबाबत प्रात्यक्षिक स्वरूपातून सविस्तर माहिती.",
      "ई.व्ही. वाहनांची गरज, रचना, कार्य आणि दुरुस्ती प्रात्यक्षिकातून.",
      "गाडीचे कॉम्प्युटराइज्ड व्हील अलायमेंट — महत्त्व, टेस्टिंग व सेटिंग.",
      "विद्यार्थ्यांना ड्रायव्हिंगचेही प्रशिक्षण दिले जाते.",
    ],
    prospects: [
      "स्वतःचे ऑटोमोबाईल गॅरेज सुरू करता येते.",
      "ऑटोमोबाईल स्पेअर पार्ट विक्रीचा व्यवसाय.",
      "ऑईल, टायर, बॅटरी विक्रीचा व्यवसाय.",
      "स्वतःचे सर्व्हिसिंग सेंटर (2 & 4 Wheeler).",
      "व्हील अलायमेंट वर्कशॉप.",
      "फ्युएल इंजेक्शन पंप दुरुस्ती व कॅलिब्रेशन सेंटर.",
      "शासकीय व अशासकीय संस्थांत शिल्प निदेशक म्हणून नोकरी.",
      "महिंद्रा, टाटा, आयशर, ह्युंदाई अशा मोठ्या ऑटोमोबाईल कंपन्यांमध्ये नोकरी.",
      "रेल्वे, एस.टी. महामंडळ इत्यादी ठिकाणी मेकॅनिक म्हणून नोकरी.",
    ],
  },
];

export const OBJECTIVES = [
  "कारखान्यात विविध कामांसाठी लागणाऱ्या कुशल मनुष्यबळाचा पुरवठा करणे व स्वतःचा व्यवसाय सुरू करण्यासाठी प्रोत्साहित करणे.",
  "युवकांना प्रशिक्षण देऊन कारखान्यात रोजगार मिळविण्यासाठी सक्षम बनवणे.",
  "युवकांना कौशल्याभिमुख प्रशिक्षण देऊन उत्पादन व इतर सेवा क्षेत्रामध्ये स्वयंरोजगार सुरू करण्यासाठी सक्षम बनविणे.",
  "औद्योगिक आस्थापनांचा दर्जा, गुणवत्ता व उत्पादन वाढविण्यासाठी सहकार्य करणे.",
];

export const FEATURES = [
  "संस्थेतील सर्व व्यवसाय तुकड्यांना राज्य शासनाची संलग्नता प्राप्त आहे.",
  "अत्याधुनिक यंत्रसामग्रीसह सुसज्ज इमारत व कार्यशाळा.",
  "अनुभवी व तज्ज्ञ शिक्षकवर्ग.",
  "प्रशस्त संगणक लॅब.",
  "सुसज्ज ग्रंथालय.",
  "रोजगार व स्वयंरोजगार मार्गदर्शन केंद्र.",
  "अभ्यासक्रम, परीक्षा पद्धत व प्रमाणपत्र — एच.एस.सी. बोर्डाच्या नियमानुसार.",
];

export const AFFILIATION = "महाराष्ट्र राज्य माध्यमिक व उच्च माध्यमिक मंडळ, पुणे यांची संलग्नता प्राप्त — क्रमांक 56.01.066";

export function PageHero({ eyebrow, title, sub }) {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-[#14532D] via-[#166534] to-[#14532D] text-white">
      <div className="absolute inset-0 opacity-[0.12]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #F59E0B 0, transparent 40%), radial-gradient(circle at 80% 80%, #FEF8E8 0, transparent 40%)" }} />
      <div className="relative max-w-6xl mx-auto px-5 py-14">
        {eyebrow && <div className="text-[10px] uppercase tracking-[0.35em] font-bold text-[#F59E0B]">{eyebrow}</div>}
        <h1 className="font-serif text-3xl sm:text-4xl mt-2 leading-tight">{title}</h1>
        {sub && <p className="mt-3 text-white/85 text-sm max-w-3xl leading-relaxed">{sub}</p>}
      </div>
    </div>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`max-w-6xl mx-auto px-5 py-14 ${className}`}>{children}</section>;
}
